import React from 'react';
import { IMealCredit } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';
import { AccordionGroupSingleOpen } from 'src/components/oneCorp/features/MealCredit/common/Accordion/AccordionGroupSingleOpen';
import { GroupsAccordion } from 'src/components/oneCorp/features/MealCredit/components/DetailsPage/AccordionSections/GroupsAccordion/GroupsAccordion';
import { PeopleAccordion } from 'src/components/oneCorp/features/MealCredit/components/DetailsPage/AccordionSections/PeopleAccordion/PeopleAccordion';

interface AccordionSectionsProps {
  mealCredit: IMealCredit;
  corpId: string;
  fetchMealCredit: () => Promise<void>;
}

export function AccordionSections({
  mealCredit,
  corpId,
  fetchMealCredit,
}: AccordionSectionsProps): JSX.Element {
  return (
    <AccordionGroupSingleOpen>
      <PeopleAccordion
        mealCredit={mealCredit}
        corpId={corpId}
        fetchMealCredit={fetchMealCredit}
      />
      <GroupsAccordion
        defaultExpanded
        mealCredit={mealCredit}
        corpId={corpId}
        fetchMealCredit={fetchMealCredit}
      />
    </AccordionGroupSingleOpen>
  );
}
